document.addEventListener("DOMContentLoaded", function () {
    const searchButton = document.getElementById("search-button");
    const cardInput = document.getElementById("card-input");
    const resultsContainer = document.getElementById("deck-builder-results");

    if (!searchButton || !cardInput || !resultsContainer) {
        console.error("❌ Elementos necesarios no encontrados en el DOM.");
        return;
    }

    const updateCartButton = document.createElement("button");
    updateCartButton.id = "update-cart-button";
    updateCartButton.textContent = "Actualizar Carrito";
    updateCartButton.style.display = "none";
    resultsContainer.before(updateCartButton);

    async function getCurrentCart() {
        try {
            const response = await fetch("/cart.js");
            if (!response.ok) throw new Error("No se pudo obtener el carrito.");
            return await response.json();
        } catch (err) {
            console.error("❌ Error obteniendo el carrito:", err);
            return null;
        }
    }

    searchButton.addEventListener("click", async function () {
        const rawList = cardInput.value
            .trim()
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line !== "");

        const parsedCardList = rawList.map((line) => {
            const match = line.match(/^(\d+)\s+(.*)$/);
            if (match) {
                return { quantity: parseInt(match[1]), name: match[2].toLowerCase() };
            }
            return { quantity: 1, name: line.toLowerCase() };
        });

        resultsContainer.innerHTML = "<p>Buscando cartas...</p>";
        updateCartButton.style.display = "none";

        try {
            const groupedResults = {};

            for (const { name: card, quantity: requestedQty } of parsedCardList) {
                const query = `
                {
                    products(first: 50, query: "title:*${card}* AND available_for_sale:true") {
                        edges {
                            node {
                                title
                                images(first: 1) {
                                    edges {
                                        node {
                                            src
                                        }
                                    }
                                }
                                variants(first: 50) {
                                    edges {
                                        node {
                                            id
                                            price {
                                                amount
                                                currencyCode
                                            }
                                            availableForSale
                                            quantityAvailable
                                            selectedOptions {
                                                name
                                                value
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }`;

                const response = await fetch("/api/2023-10/graphql.json", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": "aed498da6e263a34596494fcdcdec75f",
                    },
                    body: JSON.stringify({ query }),
                });

                const data = await response.json();

                if (data && data.data && data.data.products.edges.length) {
                    data.data.products.edges.forEach(({ node: product }) => {
                        const productTitle = product.title;
                        const productImage = product.images.edges.length
                            ? product.images.edges[0].node.src
                            : "default-image.jpg";

                        if (!groupedResults[productTitle]) {
                            groupedResults[productTitle] = {
                                title: productTitle,
                                image: productImage,
                                variants: [],
                                requestedQty: requestedQty
                            };
                        }

                        product.variants.edges.forEach(({ node: variant }) => {
                            if (variant.availableForSale && variant.quantityAvailable > 0) {
                                const variantTitle = variant.selectedOptions.map(opt => opt.value).join(" / ");

                                groupedResults[productTitle].variants.push({
                                    id: variant.id,
                                    price: variant.price,
                                    quantityAvailable: variant.quantityAvailable,
                                    image: productImage,
                                    title: variantTitle
                                });
                            }
                        });
                    });
                }
            }

            resultsContainer.innerHTML = "";

            Object.values(groupedResults).forEach((group) => {
                let remainingQty = group.requestedQty;

                let groupHTML = `
                    <div class="deck-group">
                        <h2 class="deck-group-title">${group.title}</h2>
                        <div class="deck-group-items">
                `;

                if (group.variants.length > 0) {
                    group.variants.forEach((variant) => {
                        const assignQty = Math.min(variant.quantityAvailable, remainingQty);
                        remainingQty -= assignQty;

                        groupHTML += `
                            <div class="deck-item">
                                <img src="${variant.image}" alt="${group.title}">
                                <div class="deck-item-info">
                                    <p class="variant-title">${variant.title}</p>
                                    <p class="price"><strong>${parseInt(variant.price.amount)} ${variant.price.currencyCode}</strong></p>
                                    <p class="deck-item-stock">Stock: ${variant.quantityAvailable}</p>
                                    <select class="quantity-selector" data-variant-id="${variant.id}">
                                        ${Array.from({ length: variant.quantityAvailable + 1 }, (_, i) =>
                                            `<option value="${i}" ${i === assignQty ? "selected" : ""}>${i}</option>`
                                        ).join("")}
                                    </select>
                                </div>
                            </div>
                        `;
                    });
                } else {
                    groupHTML += `
                        <div class="deck-item no-stock-item">
                            <p>No hay productos disponibles para esta carta.</p>
                        </div>
                    `;
                }

                groupHTML += `</div></div>`;
                resultsContainer.insertAdjacentHTML("beforeend", groupHTML);
            });

            resultsContainer.insertAdjacentHTML("beforeend", `<div style="height: 50px;"></div>`);
            updateCartButton.style.display = "block";
        } catch (error) {
            console.error("❌ Error al buscar cartas:", error);
            resultsContainer.innerHTML = "<p>Error al buscar cartas.</p>";
            updateCartButton.style.display = "none";
        }
    });

    updateCartButton.addEventListener("click", async function () {
        const selectors = document.querySelectorAll(".quantity-selector");

        const currentCart = await getCurrentCart();
        if (!currentCart) {
            alert("❌ No se pudo obtener el carrito actual.");
            return;
        }

        const currentQuantities = {};
        currentCart.items.forEach((item) => {
            currentQuantities[item.variant_id] = item.quantity;
        });

        const updates = {};

        selectors.forEach((selector) => {
            const variantId = selector.getAttribute("data-variant-id");
            const numericId = variantId.split("/").pop();
            const desiredQty = parseInt(selector.value, 10);

            if (desiredQty > 0) {
                const currentQty = currentQuantities[numericId] || 0;
                updates[numericId] = desiredQty;
            }
        });

        if (Object.keys(updates).length === 0) {
            alert("❌ No se han seleccionado productos para actualizar el carrito.");
            return;
        }

        try {
            const response = await fetch("/cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ updates }),
            });

            if (response.ok) {
                alert("✅ Carrito actualizado con éxito!");
            } else {
                const errorData = await response.json();
                console.error("❌ Error al actualizar el carrito:", errorData);
                alert(`❌ Error al actualizar el carrito: ${errorData.message}`);
            }
        } catch (error) {
            console.error("❌ Error al enviar datos al carrito:", error);
            alert("❌ Error al actualizar el carrito.");
        }
    });
});